<template>
	<div>
		<notifications />
		<div class="row">
			<div class="col-xs-12 col-md-6">
				<section class="heading">
					<h1 class="title">Kick Off</h1>
				</section>
				<p>
					Tidak perlu bingung lagi buat kamu yang mau menghitung biaya tetap buat agency kalian.
				</p>
				<p>
					Amy sudah buat 3 langkah mudah untuk menghitung biaya tetap kamu.
				</p>
				<div class="text-center">
					<img :src="relativeUrl('/img/Rounded Rectangle 8.png')" class="img-responsive">
					<br>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="well well-lg">
					<h2>Total</h2>
					<ol class="steps">
						<li>01 Biaya per bulan</li>
						<li>02 Aset</li>
						<li class="active">03 Selesai</li>
					</ol>
					<br>
					<div class="row" v-for="(category, i) in expenseCategories" :key="i">
						<div class="col-sm-7">
							<label>{{ category.name }}</label>
						</div>
						<div class="col-sm-5">
							<span class="color-primary">{{ formatPrice(category.price) }}</span>
						</div>
					</div>
					<div class="row" v-for="(asset, i) in assets" :key="i">
						<div class="col-sm-7">
							<label>{{ asset.name }}</label>
						</div>
						<div class="col-sm-5">
							<span class="color-primary">{{ formatPrice(asset.monthly_cost) }}</span>
						</div>
					</div>
					<hr class="primary">
					<div class="row">
						<div class="col-sm-7">
							<h4><b>Total biaya bulanan</b></h4>
						</div>
						<div class="col-sm-5">
							<h4><b>{{ subtotal }}</b></h4>
						</div>
					</div>
					<div class="row" style="margin-bottom: 50px;">
						<div class="col-sm-7">
							<h4><b>Estimasi beban harian</b></h4>
						</div>
						<div class="col-sm-5">
							<h4><b>{{ dailyCost }}</b></h4>
						</div>
					</div>
					<div class="text-right">
						<router-link 
							to="../proposals" 
							class="btn btn-primary btn-lg"
							:disabled="isLoading">
							<i v-show="isLoading" class="fa fa-circle-o-notch fa-spin"></i>
							Buat Proposal
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { relativeUrl, formatPrice } from "../../helpers";

export default {
	data() {
		return {
			assets: [],
			expenseCategories: [],
			isLoading: false,
		}
	},
	computed: {
		subtotal() {
			return formatPrice(this.getSubtotal());
		},
		dailyCost() {
			return formatPrice( this.getSubtotal() / 22 );
		}
	},
	methods: {
		formatPrice,
		relativeUrl,
		getSubtotal() {
			let expenses = this.expenseCategories.reduce((total, item) => {
				return total + item.price;
			}, 0);
			let assets = this.assets.reduce((total, item) => {
				return total + item.monthly_cost;
			}, 0);

			return expenses + assets;
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			let response = await axios.get('/base-price/calculate');
			let data = response.data.data;
			this.assets = data.assets;
			this.expenseCategories = data.expense_categories;
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!',
			})
		}

		this.isLoading = false;
	},
}
</script>

<style lang="less" scoped>
.listing-title {
	display: inline;
	margin: 0;
	vertical-align: middle;
}
.asset-item:not(:last-of-type) {
	padding-bottom: 10px;
}
</style>
